import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { CatalogGroupNumbers } from '../products/index'
import { APIResponse } from '../../helpers'
import { LKQJobPostData, RepairJobs } from './types'
import { HttpMethod } from '../../http-method'
import { ForeignSystemType } from '../enums'
import { POSTWorkorderLineResponse } from '../workorder'
import { AsyncAction } from '@cbgms/base/redux/async-action'

const GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_REQUEST = 'GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_REQUEST'
const GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_SUCCESS = 'GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_SUCCESS'
const GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_FAILED = 'GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_FAILED'

export const getRepairJobsByCatalogGroupNumbers = (vehicleUUID: string, catalogGroupNumbers: CatalogGroupNumbers) =>
  AsyncAction<APIResponse<RepairJobs>>({
    type: [
      GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_REQUEST,
      GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_SUCCESS,
      GET_REPAIR_JOBS_BY_CATALOG_GROUP_NUMBERS_FAILED
    ],
    payload: {
      api: 'gms',
      vehicleUUID,
      skipVehicleSelection: true,
      request: {
        method: 'POST',
        url: `/modules/jobs/${vehicleUUID}`,
        data: catalogGroupNumbers
      }
    }
  })

export const postRepairJobsToWorkOrder = (workorderUUID: string, foreignType: ForeignSystemType, Data: LKQJobPostData) =>
  createAsyncApiAction<POSTWorkorderLineResponse>('POST_ORDER_LINE', 'gms', {
    method: HttpMethod.POST,
    url: `/modules/workorders/${workorderUUID}/foreign-system/${foreignType}`,
    data: Data
  })
